import React from 'react'
import PropTypes from 'prop-types'

import { Grid, Typography } from '@material-ui/core'

import useMobileBreakpoint from 'artkive/hooks/useMobileBreakpoint'

import BrushStrokes from 'images/ecom/brand/brushStrokes.svg'
import BubblesImage from 'images/ecom/bubbles.svg'

import {
  Bubbles,
  CardBody,
  CardBodyWrapper,
  CardImage,
  Cards,
  CardsWrapper,
  CardText,
  Foreground,
  IntroBlock,
  IntroText,
  Outro,
  OutroWrapper,
  Paragraph,
  Section,
  Sprite,
} from './ImageCardRow.style'
import { CARD_IMAGE_RATIO, MOBILE_IMAGE_RATIO } from './Keepsakes.constants'
import Phrases from './Phrases'

const ImageCardRow = ({ intro, cards, outro, ...rest }) => {
  const isMobile = useMobileBreakpoint()

  return (
    <Section {...rest}>
      <IntroBlock>
        <Sprite src={BrushStrokes} alt='' />
        <Bubbles src={BubblesImage} alt='' />
        <Foreground>
          {intro.map((paragraph, index) => (
            <Paragraph key={index}>
              <IntroText variant='h3' component='p'>
                {paragraph}
              </IntroText>
            </Paragraph>
          ))}
        </Foreground>
      </IntroBlock>
      <Foreground>
        <CardsWrapper>
          <Cards container spacing={isMobile ? 0 : 5}>
            {cards.map(({ title, body, image, alt }) => (
              <Grid xs={12} md={4} item key={title}>
                <div>
                  <CardImage ratio={isMobile ? MOBILE_IMAGE_RATIO : CARD_IMAGE_RATIO} src={image} alt={alt} />
                  <CardText>
                    <Typography variant='h3'>
                      <Phrases text={title} />
                    </Typography>
                    {body && (
                      <CardBodyWrapper>
                        <CardBody variant='body1'>{body}</CardBody>
                      </CardBodyWrapper>
                    )}
                  </CardText>
                </div>
              </Grid>
            ))}
          </Cards>
        </CardsWrapper>
        {outro && (
          <OutroWrapper>
            <Outro variant='body1'>{outro}</Outro>
          </OutroWrapper>
        )}
      </Foreground>
    </Section>
  )
}

ImageCardRow.propTypes = {
  intro: PropTypes.arrayOf(PropTypes.node).isRequired,
  cards: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      body: PropTypes.string,
      image: PropTypes.string.isRequired,
      alt: PropTypes.string.isRequired,
    }),
  ).isRequired,
  outro: PropTypes.node,
}

export default ImageCardRow
